import React, { useCallback, useEffect, useRef, useState } from 'react';
import LoadingOverlay from 'react-loading-overlay';
import { MDBCol, MDBRow, Fa } from 'mdbreact';
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { withTheme } from '../../../themes/theming';
import Slider from "react-slick";
import { fetchActivityStatus, fetchScrollableWidgetDataNAS } from '../../../actions/dashboardAction';
import Arrow from '../arrow';
import * as AppConstant from '../../../AppConstant';

const Card = (props) => {
    var I18n = require("react-redux-i18n").I18n;
    const { statusP, status, dispatch, name, isLexusValue, isPercentage} = props; // Destructure the required props
    const [data, setData] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [leftArrow, setLeftArrow] = useState("widget_filter_arrow_disable");
    const [rightArrow, setRightArrow] = useState("widget_filter_arrow");
    const hasFetchedDataRef = useRef(false);

    const onSuccess = (response) => {
        setData(response);
        //setIsLoading(false);
    };

    const onFailure = (error) => {
        console.log("❌ Error while fetching list of video", error);
    };

    const fetchData = (status) => {
        if (!props.toolboxByType?.toolboxByType || props.toolboxByType.toolboxByType?.length === 0) {
            return;
        }
        // For initial toolbox selection
       // const initialToolBoxId = props.activityToolBox.activityToolBox[props.activityToolBox.activityToolBox.length - 1]
        /** initial start date and end date */
       // const initialCycle = props.cycleDataList[props.cycleDataList?.length - 1];
       // const [initialStartDate, initialEndDate] = initialCycle.cycle.split(" to ");

        const toolBoxList = props.toolboxByType?.toolboxByType;
        const cycleList = props.cycleDataList;
    
        if (!toolBoxList || toolBoxList.length === 0 || !cycleList || cycleList.length === 0) {
            console.warn("Required data is not ready yet.");
            return;
        }
    
        const initialToolBoxId = toolBoxList[toolBoxList.length - 1];
        const initialCycle = cycleList[cycleList.length - 1];
    
        if (!initialCycle?.cycle) {
            console.warn("Initial cycle format is missing.");
            return;
        }
    
        const [initialStartDate, initialEndDate] = initialCycle.cycle.split(" to ");
        // setIsLoading(true);
        const activeProgram = props.existingProps.userMdl.activeProgram;
        const nmscCode = props.existingProps.userMdl.nmsc;
        const langCode = props.existingProps.userMdl.lang;
        let queryDto = {
            userNmscCode: nmscCode,
            userLangCode: langCode,
            programList: [activeProgram],
            nmscCode: props.existingProps.nmscFlag ? [nmscCode.toUpperCase()] : props.existingProps.nmscFilter,
            brand: props.existingProps.brandFilter,
            country: props.existingProps.countryFilter,
            region: props.existingProps.regionFilter,
           // widgetFilter: status,
            userId: props.existingProps.userMdl.username,
            businessArea: props.existingProps.userMdl.businessAreaKey,
        };
        
        /** only for assigned location as global filters should not affect on this */
        if (name === AppConstant.NAS_DASHBOARD_CARD.ASSIGNEDLOCATION) {
            queryDto = {
                userId: props.existingProps.userMdl.username,
                businessArea: props.existingProps.userMdl.businessAreaKey,
            };
        }

        if (name === AppConstant.NAS_DASHBOARD_CARD.COMPLIANT || name === AppConstant.NAS_DASHBOARD_CARD.ASSIGNEDLOCATION) {
            // Do nothing, neither phaseKey nor widgetFilter should be set
        } else if (name === AppConstant.NAS_DASHBOARD_CARD.PROGRESS|| name === AppConstant.NAS_DASHBOARD_CARD.PASSING|| name === AppConstant.NAS_DASHBOARD_CARD.KAIZEN || name === AppConstant.NAS_DASHBOARD_CARD.SCORE) {
            queryDto["phaseKey"] = status;
        } else {
            queryDto["widgetFilter"] = status;
        }
    
        if (activeProgram === "NAS" && name !== AppConstant.NAS_DASHBOARD_CARD.ASSIGNEDLOCATION) {
            queryDto["toolboxIDList"] = (props.existingProps.toolboxIDList?.length > 0) ? props.existingProps.toolboxIDList : [Number(initialToolBoxId?.packageMapPrimaryKey)];
            queryDto["startDate"] = props.existingProps.startDate !== "" ? props.existingProps.startDate : initialStartDate;
            queryDto["endDate"] = props.existingProps.endDate !== "" ? props.existingProps.endDate : initialEndDate;
        }
        // Add a2dFilter only when businessAreaKey is "value chain"
        if (activeProgram === "NAS") {
             queryDto.dealerOperations = props.existingProps.dealerOperations?.length > 0 ? props.existingProps.dealerOperations : (AppConstant.AUTO_DEFAULT_FILTER[activeProgram] || ['All']);
        }

        if (typeof name === "string" && name.trim() !== "") dispatch(fetchScrollableWidgetDataNAS(name, queryDto, onSuccess, onFailure));
    }

    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        beforeChange: (current, next) => {
            const currentStatus = status[next];
            if (currentStatus) {
                fetchData(currentStatus.value);
            }

            if (next === 0) {
                setLeftArrow("widget_filter_arrow_disable");
                setRightArrow("widget_filter_arrow");
            } else if (next === (status.length - 1)) {
                setRightArrow("widget_filter_arrow_disable");
                setLeftArrow("widget_filter_arrow");
            } else {
                setRightArrow("widget_filter_arrow");
                setLeftArrow("widget_filter_arrow");
            }
        },
        prevArrow: <Arrow icon="chevron-left" parentClass="previousBtnClass" BtnClass={leftArrow} />,
        nextArrow: <Arrow icon="chevron-right" parentClass="nextBtnClass" BtnClass={rightArrow} />
    };

    useEffect(() => {
        const toolboxReady = props.toolboxByType?.toolboxByType?.length > 0;
        const cycleReady = props.cycleDataList?.length > 0;
    
        if (!hasFetchedDataRef.current && toolboxReady && cycleReady) {
            const defaultStatus = status?.[0]?.value || null;
    
            // Call fetchData with status only if necessary
            if (defaultStatus || name === AppConstant.NAS_DASHBOARD_CARD.COMPLIANT || name === AppConstant.NAS_DASHBOARD_CARD.ASSIGNEDLOCATION) {
                fetchData(defaultStatus); // can be undefined/null — your logic handles it
                hasFetchedDataRef.current = true;
            }
        }
    }, [props.toolboxByType, props.cycleDataList, status]);
    
    
    return (
        <div>
            <div className={`widget-header widget-header-${props.theme.name}`} title={props?.header}>
                {props.title}
            </div>
            <LoadingOverlay
                //active={isLoading} 
                spinner text='Loading...'>
                <div className="scrollable-widget-content">
                    <MDBRow style={{ minHeight: "3.2rem", paddingLeft: "3px" }}>
                        <MDBCol lg="12" md="12">
                            <div className="widget_count_class">
                                {isPercentage ? `${data.value || 0}%` : data.value}
                                {data.arrowDirection ?
                                    <Fa icon={data.arrowDirection} style={{ color: data.arrowColor }}
                                        className="widget_arrow_class" size="lg" />
                                    : <div></div>}
                            </div>
                        </MDBCol>
                    </MDBRow>
                    {statusP ? <MDBRow style={{ minHeight: "1.7rem" }}>
                        <MDBCol lg="12" md="12" className="widget-header_sub " style={{ paddingLeft: "8px" }}>
                            {statusP}
                        </MDBCol>
                    </MDBRow> : isLexusValue ? null : <MDBRow style={{ minHeight: "1.7rem" }}> <MDBCol lg="12" md="12" className="widget-header_sub " style={{ paddingLeft: "8px" }}></MDBCol></MDBRow>}
                    {status && <MDBRow style={{ minHeight: "1.7rem" }}>
                        <MDBCol lg="12" md="12" className="widget_slider_class">
                            <Slider {...settings}>
                                {status?.map((t, i) => (
                                    <div key={i}>
                                        <span className="widget_filter" title={I18n.t('status.' + t.label)} style={{ paddingRight: "3px" }}>
                                            {I18n.t('status.' + t.label)}
                                        </span>
                                    </div>
                                ))}
                            </Slider>
                        </MDBCol>
                    </MDBRow>}
                    {isLexusValue && <MDBRow className="widget_brand_count_section" style={{}}>
                        <MDBCol lg="6" md="6">
                            <img src="images/TMEToyotaEllipse.png" alt="logo" height="21px" className="theme_logo" />
                        </MDBCol>
                        <MDBCol lg="6" md="6">
                            <img src="images/Lexus2D.jpg" alt="logo" height="20px" className="theme_logo" />
                        </MDBCol>
                    </MDBRow>}
                    {isLexusValue && <MDBRow>
                        <MDBCol lg="6" md="6" className="widget_brand_count">{data?.toyotaValue ?? 0} %</MDBCol>
                        <MDBCol lg="6" md="6" className="widget_brand_count">{data?.lexusValue ?? 0} %</MDBCol>
                    </MDBRow>}
                </div>
            </LoadingOverlay>
        </div>
    );
};

const mapStateToProps = state => {
    return {
        user: state.loginReducer,
        activityToolBox: state.activityReducer,
        cycleDataList: state.dashboardReducer.cycleDataList,
        toolboxByType: state.leftNavReducer
    };
};
export default withRouter(connect(mapStateToProps)(withTheme(Card)));
